import { useState } from 'react'
import { Alert, Button, Container, Spinner } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { Block } from './components/blocks/Block'
import { useCreateEvaluationResultMutation, useGetEvaluationQuery } from './services/evaluations'
import { toast } from 'react-toastify'

export function App() {
    const params = useParams()
    const uuid = params.uuid

    const [result, setResult] = useState<any>({})
    const [errors, setErrors] = useState<any>({})
    const [submitted, setSubmitted] = useState<boolean>(false)

    const {
        data: evaluation,
        isFetching: isFetchingEvaluation,
        isError,
    } = useGetEvaluationQuery(uuid, {
        skip: !uuid,
    })
    const [createResult, { isLoading: isCreatingResult }] = useCreateEvaluationResultMutation()

    const onSubmit = async () => {
        if (!evaluation) return

        const missingFields = evaluation.struct.filter((block: any) => block.required && !result[block.identifier])
        setErrors(missingFields.reduce((acc: any, block: any) => ({ ...acc, [block.identifier]: true }), {}))

        if (missingFields.length > 0) {
            toast.error('Certains champs obligatoires sont manquants.')
            return
        }

        const response: any = await createResult({
            uuid,
            result,
        })
        if (response.error) return

        toast.success(response.data.message)
        setSubmitted(true)
    }

    if (!uuid) {
        return (
            <Container className="py-5">
                <div className="min-vh-100 d-flex align-items-center justify-content-center">
                    <div className="text-center" style={{ maxWidth: 560 }}>
                        <h1 className="mb-3">Évaluation introuvable</h1>
                        <Alert variant="warning" className="mb-0">
                            Ouvre un lien de session valide pour afficher le questionnaire.
                        </Alert>
                    </div>
                </div>
            </Container>
        )
    }

    if (isFetchingEvaluation) {
        return (
            <Container className="py-5">
                <div className="min-vh-100 d-flex justify-content-center align-items-center">
                    <div className="d-flex flex-column align-items-center">
                        <Spinner animation="grow" className="mb-4" />
                        <h4>Chargement</h4>
                    </div>
                </div>
            </Container>
        )
    }

    if (isError || !evaluation) {
        return (
            <Container className="py-5">
                <div className="min-vh-100 d-flex justify-content-center align-items-center">
                    <div className="d-flex flex-column align-items-center text-center">
                        <h4>Cette évaluation n'est pas ou plus accessible.</h4>
                    </div>
                </div>
            </Container>
        )
    }

    return (
        <Container className="py-5">
            <h1 className="mb-5">{evaluation.sessionName}</h1>
            {evaluation.struct.map((block: any, i: number) => (
                <div key={i}>
                    {errors[block.identifier] && <div className="text-danger">Cette question doit être remplie.</div>}
                    <Block.Render
                        onUpdate={(key: string, value: any) =>
                            setResult({
                                ...result,
                                [key]: value,
                            })
                        }
                        {...block}
                    />
                </div>
            ))}

            <Button variant="primary" onClick={onSubmit} disabled={submitted || isCreatingResult}>
                {submitted ? 'Évaluation envoyée' : isCreatingResult ? 'Envoi en cours' : 'Envoyer résultat'}
            </Button>
        </Container>
    )
}
